import { Top5State } from './State'
import { SET_WORD_BANKS, SET_IS_LOADING, SET_IS_SUBMITTING, SET_IS_LOADING_CATEGORIES, Top5Action } from './Actions'

function top5Reducer(state: Top5State, action: Top5Action): Top5State {
  switch (action.type) {
    case SET_WORD_BANKS:
      return Object.assign({}, state, { wordBanks: { ...state.wordBanks, ...action.payload } })
    case SET_IS_LOADING:
      return Object.assign({}, state, { isLoading: { ...state.isLoading, ...action.payload } })
    case SET_IS_SUBMITTING:
      return Object.assign({}, state, { isSubmitting: { ...state.isSubmitting, ...action.payload } })
    case SET_IS_LOADING_CATEGORIES:
      return Object.assign({}, state, { isLoadingCategories: action.payload })
    default:
      return state
  }
}

export default top5Reducer
